import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.some.js";
import _ from "lodash";
export default (array, key, value) => {
  var o;
  if (_.isArray(array)) {
    array.some(function iter(a) {
      if (a[key] === value) {
        o = a;
        return true;
      }
      return !!Array.isArray(a.children) && a.children.some(iter);
    });
    return o && [o];
  } else {
    return null;
  }
};